import { getLanguageFileUrl } from '../services/translations/getLanguageFileUrl';
import { DEFAULT_LANGUAGE } from '../services/translations/getSafeLanguage';

const loadedLocales: Record<string, any> = {};

export const getFormioTranslation = async (lang: string) => {
  if (loadedLocales[lang]) {
    return loadedLocales[lang];
  }

  const languageFileUrl = getLanguageFileUrl(lang, 'form');
  const response = await fetch(languageFileUrl);
  const translation = await response.json();

  loadedLocales[lang] = translation;

  return translation;
};

export const getLangCode = (langCode: string) => {
  const languageParts = langCode.split("-");
  return languageParts[0];
};

export const setFormioI18nSetting = async (
  lang: string,
  settingsArray: any[]
) => {
  try {
    const formioTranslate = await getFormioTranslation(lang);

    if (formioTranslate) {
      settingsArray.forEach((setting) => {
        setting.i18n = {};
        // need set "en" always, because bug on add datetime component in formio not trigger event https://github.com/formio/formio.js/issues/5228
        setting.i18n["en"] = formioTranslate;
        setting.language = "en";
      });
    }
  } catch (e) {
    if (lang !== DEFAULT_LANGUAGE) {
      try {
        await setFormioI18nSetting(DEFAULT_LANGUAGE, settingsArray);
      } catch (e) {
        console.log(e);
      }
    } else {
      console.log(e);
    }
  }
};
